import { b } from './chunk-IMSWER4T.js';

var o=class extends b{URL="scheduled-pipelines";async getAll(e){let t={type:"export"};return await super.getAll(e,t)}async restartScheduledExport(e){await this._client.post(`/scheduled-pipelines/${e}/run`);}async updateScheduledExportProducts(e,t){await this._client.put(`/${this.URL}/${e}/update-products`,t);}async getScheduledPipelineProducts(e){return (await this._client.get(`/${this.URL}/${e}/products`)).data.data}};

export { o as a };
//# sourceMappingURL=chunk-A4C26IF3.js.map
//# sourceMappingURL=chunk-A4C26IF3.js.map